import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgRepeatCash = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM16.5394 16.9998L14.7901 15.2456L15.5118 14.5256L15.5148 14.5222C16.2164 13.7335 17.8534 11.8931 16.8382 9.54819C16.1676 8.00087 14.6171 7 12.8816 7H7.5V17H9.24234V8.74667H12.8814C13.9203 8.74667 14.8453 9.33435 15.2391 10.242C15.6556 11.2026 15.3797 12.044 14.2265 13.3436L13.5598 14.0123L11.7992 12.2477V16.9998H16.5394Z",
		fill: "inherit"
	})
});
export default SvgRepeatCash;
